import { useClipboard } from '@vueuse/core'

import type { Ref } from 'vue'

interface DisciplinePaymentLinkFieldOptions {
  link: ComputedRef<string>
}

interface DisciplinePaymentLinkFieldReturn {
  refIsSupported: Ref<boolean>
  refIsCopied: Ref<boolean>
  copyLink: () => Promise<void>
}

/** As in legacy, a copy is confirmed by the button's own tooltip for a second, not by a toast. */
const COPIED_TOOLTIP_MS = 1000

/** The link logs the customer in: it is copied on demand only, never logged or prefetched. */
export const useDisciplinePaymentLinkField = ({ link }: DisciplinePaymentLinkFieldOptions): DisciplinePaymentLinkFieldReturn => {
  const { copy, copied, isSupported } = useClipboard({ copiedDuring: COPIED_TOOLTIP_MS })

  const copyLink = async (): Promise<void> => {
    if (!link.value) return

    await copy(link.value)
  }

  return {
    refIsSupported: isSupported,
    refIsCopied: copied,
    copyLink,
  }
}
